import { CircularProgress } from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";

export const StyledContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  height: 100vh;
`;
export const StyledCircularProgress = styled(CircularProgress)`
  color: #849dce;
  opacity: 0.7;
`;

export const Spinner = (props) => {
  return (
    <StyledContainer>
      <StyledCircularProgress
        thickness={6}
        disableShrink
        variant={"indeterminate"}
        size={70}
      />
    </StyledContainer>
  );
};

export default Spinner;
